import { ResponseTypes } from '../enums/response-types.enum';

export class MiniResponse {
  responseType: ResponseTypes;
  success: boolean;
  message: string;

  constructor(responseType: ResponseTypes) {
    this.responseType = responseType;
  }
}
